var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7708 6.37717C22.5115 5.41325 21.7515 4.65341 20.7877 4.39386C19.027 3.91211 11.9841 3.91211 11.9841 3.91211C11.9841 3.91211 4.94145 3.91211 3.18076 4.3756C2.23552 4.63487 1.457 5.41339 1.19772 6.37717C0.734375 8.13773 0.734375 11.7889 0.734375 11.7889C0.734375 11.7889 0.734375 15.4585 1.19772 17.2006C1.45728 18.1644 2.21698 18.9242 3.18089 19.1838C4.95999 19.6657 11.9844 19.6657 11.9844 19.6657C11.9844 19.6657 19.027 19.6657 20.7877 19.2022C21.7516 18.9428 22.5115 18.1829 22.771 17.2192C23.2342 15.4585 23.2342 11.8074 23.2342 11.8074C23.2342 11.8074 23.2528 8.13773 22.7708 6.37717ZM9.74179 15.162V8.41582L15.5983 11.7889L9.74179 15.162Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.89a985ce481860ef38beb4c82a9cfcf8.svg";
export { ForwardRef as ReactComponent };